import { loadMinicart, openMinicart } from '../components/minicart';

const quickBuyWrapper = document.querySelector('#QuickBuyDrawer');
const getSelectedVariant = (form, product) => {
  if (!form || !product) return null;
  const idField = form.querySelector('input[name="id"]');
  const submit = form.querySelector('[type="submit"]');
  if (!idField || !submit) return;

  const selectedValues = [];
  form
    .querySelectorAll('[product-option] input[type="radio"]:checked')
    .forEach((option) => {
      selectedValues.push({
        value: option.value,
        index: option.name,
      });
    });

  const variant = product?.variants?.find((variant) => {
    return selectedValues.every((value) => {
      return variant[value.index] == value.value;
    });
  });

  if (variant) {
    idField.value = variant.id;
    submit.disabled = !variant.available;
  } else {
    idField.value = '';
    submit.disabled = true;
  }

  return variant;
};

const initProductForm = (form) => {
  if (!form) return;
  const productJsonScript = form.querySelector('[product-json]');
  const idField = form.querySelector('input[name="id"]');
  if (!idField || !productJsonScript || !productJsonScript.innerHTML.trim())
    return;
  const product = JSON.parse(productJsonScript.innerHTML.trim());
  getSelectedVariant(form, product);
  form.addEventListener('change', () => {
    getSelectedVariant(form, product);

    const errorWrapper = form.querySelector('.quick-buy__error-label--shown');
    if (errorWrapper) {
      errorWrapper.classList.remove('quick-buy__error-label--shown');
    }
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (
      typeof ShopifyAPI !== 'undefined' &&
      typeof ShopifyAPI.addItemFromForm !== 'undefined'
    ) {
      ShopifyAPI.addItemFromForm(
        form,
        async () => {
          closeQuickBuy();
          await loadMinicart();
          openMinicart();
        },
        (XMLHttpRequest, textStatus) => {
          if (!XMLHttpRequest?.responseJSON?.description) return;
          const errorWrapper = form.querySelector('.quick-buy__error-label');
          if (errorWrapper) {
            errorWrapper.innerText = XMLHttpRequest?.responseJSON?.description;
            errorWrapper.classList.add('quick-buy__error-label--shown');
            setTimeout(() => {
              errorWrapper.classList.remove('quick-buy__error-label--shown');
            }, 5000);
          }
        },
      );
    } else {
      productForm.submit();
    }
  });
};

const initQuickBuy = () => {
  if (!quickBuyWrapper) return;
  const backdrop = quickBuyWrapper.querySelector('.quick-buy__backdrop');
  if (backdrop) {
    backdrop.addEventListener('click', () => {
      closeQuickBuy();
    });
  }

  const closeBtn = quickBuyWrapper.querySelector('.quick-buy__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      closeQuickBuy();
    });
  }
};

const openQuickBuy = (productUrl) => {
  const innerDrawer = quickBuyWrapper.querySelector('.quick-buy__drawer');
  if (!productUrl || !innerDrawer) return;
  fetch(
    `${productUrl}${productUrl.indexOf('?') >= 0 ? '&' : '?'}view=quick-buy`,
  )
    .then((res) => res.text())
    .then((data) => {
      const quickBuyDom = new DOMParser().parseFromString(data, 'text/html');
      const quickBuyContent = quickBuyDom.querySelector('#QuickBuyTemplate');
      if (quickBuyContent) {
        innerDrawer.innerHTML = quickBuyContent.innerHTML;
        quickBuyWrapper.classList.add('quick-buy__container--open');
        const form = innerDrawer.querySelector('form');
        if (form) {
          initProductForm(innerDrawer.querySelector('form'));
        }

        innerDrawer
          .querySelectorAll('a.quick-buy__colors-swatch[href]')
          .forEach((colorSwatch) => {
            colorSwatch.addEventListener('click', (e) => {
              e.preventDefault();
              openQuickBuy(colorSwatch.href);
            });
          });
      }
    });
};

const closeQuickBuy = () => {
  if (!quickBuyWrapper) return;
  const innerDrawer = quickBuyWrapper.querySelector('.quick-buy__drawer');

  quickBuyWrapper.classList.remove('quick-buy__container--open');
  setTimeout(() => {
    innerDrawer.innerHTML = '';
  }, 1000);
};

export { initProductForm, initQuickBuy, openQuickBuy, closeQuickBuy };
